import type { QueryClientConfig } from '@tanstack/react-query'

export const defaultQueryOptions: QueryClientConfig['defaultOptions'] = {
  queries: {
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 15 * 1000,
  },
}
